import { render, staticRenderFns } from "./update.vue?vue&type=template&id=15e9ec83"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"
import style0 from "./update.vue?vue&type=style&index=0&id=15e9ec83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports